module.exports = __webpack_public_path__ + "img/EyeBlue.1ccb9201.svg";